import { ContentTagCode } from "@config/tag-code";
import { QuestionsDocument, QuestionsQuery, QuestionsQueryVariables } from "@gql-schema";
import { addApolloState, initializeApollo } from "@shared/lib/Apollo";
import { Page } from "@shared/pages/landing-pages/ux-audit";
import { basicStaticProps } from "@shared/utils/basic-static-props";
import { GetStaticProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

export const getStaticProps: GetStaticProps = basicStaticProps(async ({ locale }) => {
    const apolloClient = initializeApollo(null);
    await apolloClient.query<QuestionsQuery, QuestionsQueryVariables>({
        query: QuestionsDocument,
        variables: {
            tagCodes: [locale === "en" ? ContentTagCode.UXAuditEn : ContentTagCode.UXAuditCs],
        },
    });

    return addApolloState(apolloClient, {
        props: {
            ...(await serverSideTranslations(locale ?? "cs", ["common", "landingPage", "reference"])),
        },
        revalidate: 10,
    });
});

export default Page;
